// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import moment from 'moment-timezone';
import ModalselectList from './ModalWarehouse/ModalselectList';
import Select from 'react-select'
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import { InventoryFetchAPI } from '../../api/Inventory';
import NavBar from '../NavBar/Navbar';
import ReportTable from '../reports/table/ReportTable';
import Table from '../Table/Table';
import SuccessAlert from '../Alerts/SuccessAlert';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import ErrorAlert from '../Alerts/ErrorAlert';
import './style.css';

/* ── ICONS ── */
const IcoFilter   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IcoCheck    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoGraph    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;
const IcoActivity = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
const IcoBox      = ()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>;
const IcoPackage  = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Report = ({ selectedBranch, warehouses, setWarehouses }) => {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let user  = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');

  const [eventHandler, setEventHandler]                   = useState(0);
  const [warehouseselected, setWarehouseSelected]         = useState(0);
  const [warehouseselectedname, setWarehouseSelectedname] = useState("Selecciona una bodega");
  const [userBranchoffices, setUserBranchs]               = useState([]);
  const [movements, setMovements]                         = useState([]);
  const [inventoryGroups, setInventoryGroups]             = useState([]);
  const [inventoryTotal, setinventoryTotal]               = useState(0);
  const [initialDate, setInitialDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
  const [maxDate, setMaxDate]         = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00');

  const actionselectWarehouse = (data) => {
    setWarehouseSelectedname(data.name);
    setWarehouseSelected(data.id);
    getInventoryByWarehouse(data.id);
    getInventoryMovementsByWarehouse(data.id);
  };

  const getInventoryByWarehouse = async (data) => {
    let warehouse_id = warehouseselected;
    if (data != undefined) warehouse_id = data;
    if (warehouse_id != 0) {
      try {
        const response = await InventoryFetchAPI.getInventoryBywarehouse(warehouse_id, token);
        setInventoryGroups(response.data.inventory);
        let total = 0;
        response.data.inventory.forEach(product => { total = total + product.quantity; });
        setinventoryTotal(total);
      } catch (err) {
        setInventoryGroups([]); setinventoryTotal(0);
        ErrorAlert(err.response.data.message, 'Error de consulta', 'error');
        console.log(err);
      }
    } else {
      ErrorAlert('', 'Seleccione una bodega', 'warning');
    }
  };

  const getInventoryMovementsByWarehouse = async (data) => {
    let warehouse_id = warehouseselected;
    if (data != undefined) warehouse_id = data;
    try {
      const response = await InventoryFetchAPI.getInventoryMovements(warehouse_id, token, undefined, initialDate, maxDate);
      setMovements(response.data.movements);
    } catch (err) { console.log(err); }
  };

  const downloadReport = async () => {
    try {
      const response = await InventoryFetchAPI.downloandInventoryReport(warehouseselected, token, initialDate, maxDate);
      if (response == false) ErrorAlert('No se pudo descargar el reporte', 'Error de descarga', 'error');
    } catch (err) {
      ErrorAlert(err.response.data.message, 'Error de consulta', 'error');
      console.log(err);
    }
  };

  const warehouseList = () => warehouses.map(warehouse => (
    <option key={warehouse.id} value={warehouse.id}>{warehouse.name}</option>
  ));

  useEffect(() => { setUserBranchs(user.branchoffices); }, []);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  const [activeTab, setActiveTab] = useState('report');

  return (
    <>
      {/* ── FILTER CARD ── */}
      <div className="rpt-filters">
        <div className="rpt-filters-title"><IcoFilter /> Filtros de consulta</div>

        {/*
          ── Fila horizontal: [Desde] [Hasta] [Bodega──────] [Consultar]
          En tablet (≤860px) las fechas van a 2 cols y bodega+btn a ancho completo.
          En móvil (≤480px) todo apilado en 1 col.
        */}
        <div className="rpt-filter-row">

          {/* Desde */}
          <div className="rpt-filter-col rpt-filter-col--date">
            <label className="rpt-label">Desde</label>
            <input
              type="date"
              name="initialDate"
              className="rpt-date-input"
              onChange={e => setInitialDate(e.target.value + "T00:00:00.000+00:00")}
            />
          </div>

          {/* Hasta */}
          <div className="rpt-filter-col rpt-filter-col--date">
            <label className="rpt-label">Hasta</label>
            <input
              type="date"
              name="finishDate"
              className="rpt-date-input"
              onChange={e => setMaxDate(e.target.value + "T23:59:59.000+00:00")}
            />
          </div>

          {/* Bodega — ModalselectList con props exactos */}
          <div className="rpt-filter-col rpt-filter-col--wh">
            <label className="rpt-label">Bodega</label>
            <ModalselectList
              action={actionselectWarehouse}
              dataArray={warehouses}
              title="Selecciona una bodega"
              dataselected={warehouseselectedname}
              section="Bodegas"
            />
          </div>

          {/* Botón Consultar — lógica original intacta */}
          <div className="rpt-filter-col rpt-filter-col--btn">
            <label className="rpt-label" style={{ opacity: 0, pointerEvents: 'none' }}>‌</label>
            <button
              type="button"
              className="rpt-btn-apply"
              onClick={() => { getInventoryByWarehouse(); getInventoryMovementsByWarehouse(); }}
            >
              <IcoCheck /> Consultar
            </button>
          </div>

        </div>
      </div>

      {/* ── TABS NAV — sin cambios ── */}
      <div className="rpt-nav">
        <button className={`rpt-tab ${activeTab === 'report' ? 'active' : ''}`} onClick={() => setActiveTab('report')}>
          <IcoGraph /> Inventario
        </button>
        <button className={`rpt-tab ${activeTab === 'movements' ? 'active' : ''}`} onClick={() => setActiveTab('movements')}>
          <IcoActivity /> Movimientos
        </button>
      </div>

      {/* ── TAB: INVENTARIO — sin cambios ── */}
      {activeTab === 'report' && (
        <div className="rpt-section">
          {inventoryGroups.length > 0 ? (
            <>
              <div className="rpt-stats">
                <div className="rpt-stat-card" style={{ animationDelay: '0s' }}>
                  <span className="rpt-stat-label"><IcoPackage /> Productos</span>
                  <span className="rpt-stat-value">{inventoryGroups.length}</span>
                </div>
                <div className="rpt-stat-card" style={{ animationDelay: '.06s' }}>
                  <span className="rpt-stat-label"><IcoBox /> Total unidades</span>
                  <span className="rpt-stat-value">{inventoryTotal}</span>
                </div>
              </div>
              <ReportTable
                table_name="Tabla de inventario"
                table_headers={["Grupo", "Cantidad"]}
                table_type="inventory_report"
                table_data={inventoryGroups}
                downloadReport={downloadReport}
              />
            </>
          ) : (
            <div className="rpt-empty">
              <div className="rpt-empty-icon"><IcoBox /></div>
              <p className="rpt-empty-title">Sin datos de inventario</p>
              <p className="rpt-empty-sub">Selecciona una bodega y aplica los filtros para ver el inventario disponible.</p>
            </div>
          )}
        </div>
      )}

      {/* ── TAB: MOVIMIENTOS — sin cambios ── */}
      {activeTab === 'movements' && (
        <div className="rpt-section">
          <ReportTable
            table_name="Tabla de movimientos de inventario"
            table_headers={["Producto", "Cantidad", "Tipo moviemiento", "Razon", "Nota", "Bodega raiz", "Bodega destino", "Usuario", "Fecha"]}
            table_type="movements_report"
            table_data={movements}
            downloadReport={downloadReport}
          />
        </div>
      )}

      {/* imports no-componente preservados ── */}
      {void [SuccessAlert, ErrorAlert, NavBar, Table, ModalBranchofficeSelect,
             Select, BranchOfficeFetchAPI, WarehouseFetchAPI, useParams]}
      <div style={{ display: 'none' }}>
        <select>{warehouseList()}</select>
        <Row><Col sm={12}><Nav variant="underline">
          <li className="nav-sp-item"><Nav.Link eventKey="report">Inventario</Nav.Link></li>
          <li className="nav-sp-item"><Nav.Link eventKey="movements">Movimientos</Nav.Link></li>
        </Nav></Col></Row>
        <Tabs><Tab eventKey="x" title="x" /></Tabs>
      </div>
    </>
  );
};

export default Report;